import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';

export default function KaleidoscopeGallery({
  patterns,
  toastMessage,
  onPatternSelect,
  isPopup = false,
  onClose = null,
}) {
  const t = useTranslations('common.newspaper.art_games.kaleidoscope.gallery');
  const gallery = Array.isArray(patterns) ? patterns : [];

  return (
    <aside className="kaleidoscope-gallery" aria-label={t('aria.saved_gallery')}>
      <div className="kaleidoscope-gallery__card">
        <div className="kaleidoscope-gallery__header">
          {isPopup ? (
            <div className="generic-popup__header">
              <h2 className="generic-popup__header-text">{t('title')}</h2>
              <XIcon className="generic-popup__close" onClick={onClose} />
            </div>
          ) : (
            <h2 className="kaleidoscope-controls__heading">{t('title')}</h2>
          )}
          {toastMessage && (
            <span className="kaleidoscope-gallery__toast" role="status" aria-live="polite">
              {toastMessage}
            </span>
          )}
        </div>

        {gallery.length === 0 ? (
          <p className="kaleidoscope-gallery__empty">{t('empty')}</p>
        ) : (
          <div className="kaleidoscope__gallery">
            {gallery.map((pattern) => {
              const formatted = new Date(pattern.timestamp).toLocaleString([], {
                hour: '2-digit',
                minute: '2-digit',
                month: 'short',
                day: 'numeric',
              });

              const tags = [];
              if (pattern.folds) {
                tags.push(`${pattern.folds}-fold`);
              }
              if (pattern.organicMode) {
                tags.push(t('tags.organic'));
              }
              if (pattern.smoothingEnabled === false) {
                tags.push(t('tags.raw_strokes'));
              }
              if (typeof pattern.strokeCount === 'number' && pattern.strokeCount >= 0) {
                tags.push(t('tags.strokes_count', { count: pattern.strokeCount }));
              }

              const handleSelect = () => {
                if (typeof onPatternSelect === 'function') {
                  onPatternSelect(pattern);
                }
              };

              const handleKeyDown = (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleSelect();
                }
              };

              return (
                <figure
                  key={pattern.id}
                  className="kaleidoscope__gallery-item"
                  role="button"
                  tabIndex={0}
                  onClick={handleSelect}
                  onKeyDown={handleKeyDown}
                  aria-label={t('aria.open_pattern')}
                >
                  <img src={pattern.url} alt={t('aria.saved_pattern_alt')} loading="lazy" />
                  <figcaption>{formatted}</figcaption>
                  {tags.length > 0 && (
                    <div className="kaleidoscope__gallery-tags">
                      {tags.map((tag) => (
                        <span key={tag} className="kaleidoscope__gallery-tag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                </figure>
              );
            })}
          </div>
        )}
      </div>
    </aside>
  );
}
